import { render, staticRenderFns } from "./5_AdminEntry.vue?vue&type=template&id=75447fc0&"
import script from "./5_AdminEntry.vue?vue&type=script&lang=js&"
export * from "./5_AdminEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports